export default __webpack_public_path__ + "static/media/group4.918bf8fc.png";